module.exports = __webpack_public_path__ + "img/cassette.9a87fd3d.jpg";